import React from 'react'
import { css } from 'emotion'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const CollectionListItemCard = ({ icon, linkTo, name }) => (
   <Link to={linkTo}>
      <View width="100%">
         <View
            position="relative"
            float="left"
            width="100%"
            paddingTop="70%"
            backgroundColor="#dedcd7"
            borderRadius="5px"
            className={css`
               &:hover {
                  background-color: #d7d5d0;
               }
            `}>
            <View
               display="flex"
               justifyContent="center"
               alignItems="center"
               position="absolute"
               top="0px"
               left="0px"
               right="0px"
               bottom="0px">
               {icon}
            </View>
         </View>
         <View
            float="left"
            width="100%"
            padding="10px 0px">
            <Text color="#000" size="2" weight="medium">
               {name}
            </Text>
         </View>
      </View>
   </Link>
)

CollectionListItemCard.propTypes = {
   icon: PropTypes.element.isRequired,
   linkTo: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired
}

export default CollectionListItemCard
